import React from 'react';
import { useUnit } from 'effector-react';
import Fade from 'react-reveal/Fade';
import { $appLoad } from 'src/models/app';
import {
  Header, Preview, Team, Experience, Steps, Form, ToTopButton,
} from 'src/ui/components/Components';
import { Seo } from 'src/ui/components/Seo';

export const Home = () => {
  const appLoad = useUnit($appLoad);

  return (
    <>
      <Seo page="home" />
      <ToTopButton />
      <Header />

      <Fade>
        <Preview />
        <Team />
        <Experience />
      </Fade>

      <Steps />

      <Fade>
        <Form />
      </Fade>

      {!appLoad ? <div className="loader" /> : null}
    </>
  );
};
